import Reveal from "@/components/site/Reveal";

const METHODS_BG =
  "https://images.unsplash.com/photo-1789413656159-e4e8b5c4f32e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxhdXR1bW4lMjBsZWF2ZXMlMjB0ZXh0dXJlJTIwd2FybSUyMG5hdHVyZXxlbnwwfHx8fDE3OTM4MDUwMTR8MA&ixlib=rb-4.1.0&q=70&w=1200&auto=format";

const steps = [
  {
    n: "01",
    title: "Erstkontakt",
    text: "Du schreibst mir über das Kontaktformular oder rufst an. Telefonisch bin ich Mo–Fr von 17–21 Uhr, Sa von 8–18 Uhr und So- & feiertags von 10–14 Uhr für dich da. Wir finden einen Termin für dein kostenloses Erstgespräch.",
  },
  {
    n: "02",
    title: "Kennenlernen",
    text: "Im unverbindlichen Erstgespräch klären wir, ob die Chemie stimmt, was dich bewegt und was du dir von der Beratung wünschst.",
  },
  {
    n: "03",
    title: "Begleitung",
    text: "In regelmäßigen Sitzungen arbeiten wir an deinen Themen – mit Methoden, die zu dir passen, und in deinem Tempo. Online oder nach Vereinbarung persönlich.",
  },
  {
    n: "04",
    title: "Integration",
    text: "Wir verankern das Erarbeitete in deinem Alltag, damit die Veränderung trägt. Auch nach der Begleitung kannst du dich jederzeit wieder melden.",
  },
];

export default function Methods() {
  return (
    <section id="ablauf" data-testid="methods-section" className="relative py-28 sm:py-36 overflow-hidden">
      {/* faded nature background — z-0 base layer, content above */}
      <div className="absolute inset-0 z-0">
        <img src={METHODS_BG} alt="" aria-hidden loading="lazy" className="w-full h-full object-cover opacity-[0.3] saturate-[1.2]" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#F2DFC6]/40 via-[#F2DFC6]/10 to-[#F2DFC6]/80" />
      </div>
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <Reveal className="max-w-2xl mb-16">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#93401D] mb-5">
            Ablauf
          </div>
          <h2 className="font-serif text-4xl sm:text-5xl lg:text-[3.5rem] tracking-tight leading-[1.02] text-[#29170C]">
            So arbeiten wir
            <br />
            <span className="italic text-[#93401D]">zusammen.</span>
          </h2>
          <p className="mt-6 text-[#63432B] text-base sm:text-lg leading-relaxed">
            Klare Schritte, viel Raum für das Persönliche. Keine starre Methode,
            sondern eine Begleitung, die sich deinem Leben anpasst.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {steps.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.08}>
              <div
                data-testid={`method-step-${s.n}`}
                className="relative h-full bg-[#FCF4E8] rounded-3xl border border-[#EAD0AE] p-7 hover:-translate-y-1 hover:shadow-[0_18px_36px_-18px_rgba(60,34,19,0.18)] transition-all duration-500"
              >
                <div className="flex items-center justify-between mb-8">
                  <div className="font-serif text-3xl text-[#C98250]">{s.n}</div>
                  <div className="h-px flex-1 ml-4 bg-[#EAD0AE]" />
                </div>
                <h3 className="font-serif text-2xl text-[#29170C] mb-3">{s.title}</h3>
                <p className="text-[15px] leading-relaxed text-[#63432B]">{s.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
